export const CURRENCIES = ['PHP', 'SGD', 'AUD', 'MYR', 'IDR', 'THB', 'VND', 'NZD', 'USD'] as const
export type Currency = (typeof CURRENCIES)[number]

// Approximate exchange rates vs USD (updated periodically)
export const EXCHANGE_RATES: Record<Currency, number> = {
  USD: 1.0,
  PHP: 56.5,     // Philippine Peso
  SGD: 1.35,     // Singapore Dollar
  AUD: 1.55,     // Australian Dollar
  MYR: 4.70,     // Malaysian Ringgit
  IDR: 15800,    // Indonesian Rupiah
  THB: 36.0,     // Thai Baht
  VND: 24500,    // Vietnamese Dong
  NZD: 1.68,     // New Zealand Dollar
}

export const CURRENCY_SYMBOLS: Record<Currency, string> = {
  USD: '$',
  PHP: '₱',
  SGD: 'S$',
  AUD: 'A$',
  MYR: 'RM',
  IDR: 'Rp',
  THB: '฿',
  VND: '₫',
  NZD: 'NZ$',
}

export const CURRENCY_NAMES: Record<Currency, string> = {
  USD: 'US Dollar',
  PHP: 'Philippine Peso',
  SGD: 'Singapore Dollar',
  AUD: 'Australian Dollar',
  MYR: 'Malaysian Ringgit',
  IDR: 'Indonesian Rupiah',
  THB: 'Thai Baht',
  VND: 'Vietnamese Dong',
  NZD: 'New Zealand Dollar',
}

export function convertUSDTo(amountUSD: number, currency: string): number {
  const rate = EXCHANGE_RATES[currency as Currency] ?? 1
  return amountUSD * rate
}

export function formatCurrency(amountUSD: number, currency: string): string {
  const converted = convertUSDTo(amountUSD, currency)
  const symbol = CURRENCY_SYMBOLS[currency as Currency] ?? '$'

  // Format based on currency
  if (currency === 'IDR' || currency === 'VND') {
    return `${symbol}${Math.round(converted).toLocaleString()}`
  }

  if (currency === 'PHP' || currency === 'THB') {
    return `${symbol}${converted.toFixed(2)}`
  }

  return `${symbol}${converted.toFixed(2)}`
}

export function formatUSD(amount: number): string {
  return `$${amount.toFixed(4)}`
}

export function formatTokens(tokens: number): string {
  if (tokens >= 1_000_000) {
    return `${(tokens / 1_000_000).toFixed(1)}M`
  }
  if (tokens >= 1_000) {
    return `${(tokens / 1_000).toFixed(1)}K`
  }
  return tokens.toString()
}

export function costPer1MTokensInCurrency(costUSD: number, currency: string): string {
  return formatCurrency(costUSD, currency)
}
